import * as yup from 'yup';

export const addPromotionValidation = yup.object({
  category: yup.string().required('*required'),
  duration: yup.string().required('*required'),
  description: yup.string().required('*required')
});
export const editPromotionValidation = yup.object({
  category: yup.string().required('*required'),
  duration: yup.string(),
  description: yup.string()
});
